import { IComponentOptions } from "angular";
import dayjs from "@gtmhub/dayjs";
import { IGoal } from "@gtmhub/goals/models";
import { ISessionsStoreState } from "@gtmhub/sessions/redux/session-reducer";
import { INgRedux } from "@gtmhub/state-management";
import { Session } from "@webapp/sessions/models/sessions.model";

interface SingleGoalSelectorGoalsListBindings {
  goals: IGoal[];
  section: string;
  unselectableId: string;
  select(args: { goal: IGoal }): void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface SingleGoalSelectorGoalsListCtrl extends SingleGoalSelectorGoalsListBindings {}
class SingleGoalSelectorGoalsListCtrl {
  public static $inject = ["$ngRedux"];

  constructor(private $ngRedux: INgRedux) {}

  public get sessionsMap(): Record<string, Session> {
    const { sessions } = this.$ngRedux.getState<ISessionsStoreState>();
    return sessions.map;
  }

  public orderBySessionEndDateDesc(goal: IGoal): number {
    return dayjs(this.sessionsMap[goal.sessionId].end).valueOf();
  }
}

export const SingleGoalSelectorGoalsListComponent: IComponentOptions = {
  template: require("./single-goal-selector-goals-list.component.html"),
  controller: SingleGoalSelectorGoalsListCtrl,
  bindings: {
    goals: "<",
    unselectableId: "<",
    section: "@",
    select: "&",
  },
};
